<template>
  <svg
    width="9"
    height="16"
    viewBox="0 0 9 16"
  >
    <path d="M0.292893 0.292893C-0.0976311 0.683418 -0.0976311 1.31658 0.292893 1.70711L6.58579 8L0.292894 14.2929C-0.0976305 14.6834 -0.0976305 15.3166 0.292894 15.7071C0.683418 16.0976 1.31658 16.0976 1.70711 15.7071L8.70711 8.70711C9.09763 8.31658 9.09763 7.68342 8.70711 7.29289L1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893Z" />
  </svg>
</template>
